import { buildAnalyticsContext } from '../config/analyticsContext';

const DEFAULT_PIXEL_ID =
  process.env.REACT_APP_META_PIXEL_ID || '2391421087948961';
const META_SCRIPT_ID = 'rely-meta-pixel';
const SAFE_CONTENT_ID = /^[A-Za-z0-9_-]{1,80}$/;

const eventMapping = {
  registration_completed: ['track', 'CompleteRegistration'],
  formation_started: ['trackCustom', 'FormationStarted'],
  checkout_started: ['track', 'InitiateCheckout'],
};

const browserWindow = () =>
  typeof window === 'undefined' ? null : window;

const currentFbq = () => {
  const windowRef = browserWindow();
  return typeof windowRef?.fbq === 'function' ? windowRef.fbq : null;
};

const defaultInjectScript = () => {
  if (typeof document === 'undefined' || document.getElementById(META_SCRIPT_ID)) {
    return;
  }
  const script = document.createElement('script');
  script.id = META_SCRIPT_ID;
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
};

const createBrowserFbq = () => {
  const windowRef = browserWindow();
  if (!windowRef) return null;
  if (typeof windowRef.fbq === 'function') return windowRef.fbq;

  const fbq = (...args) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  };
  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  windowRef.fbq = fbq;
  windowRef._fbq = fbq;
  return fbq;
};

export function initializeMetaPixel(options = {}) {
  const windowRef = browserWindow();
  const pixelId = options.pixelId ?? DEFAULT_PIXEL_ID;
  const hostname = options.hostname ?? windowRef?.location?.hostname;
  const trafficClass =
    options.trafficClass ??
    buildAnalyticsContext(hostname).traffic_class;

  if (
    !pixelId ||
    hostname !== 'app.rely.business' ||
    trafficClass !== 'commercial'
  ) {
    return false;
  }

  const fbq = options.fbq ?? createBrowserFbq();
  if (!fbq) return false;

  (options.injectScript ?? defaultInjectScript)();
  fbq('init', pixelId);
  fbq('track', 'PageView');
  return true;
}

const metaProperties = (properties = {}) => {
  const result = {
    currency: String(properties.currency || 'USD').toUpperCase(),
  };
  const amount = Number(properties.amount ?? properties.value);
  if (Number.isFinite(amount) && amount >= 0) result.value = amount;
  if (SAFE_CONTENT_ID.test(String(properties.plan || ''))) {
    result.content_ids = [String(properties.plan)];
    result.content_type = 'product';
  }
  return result;
};

export function trackMetaFunnelEvent(event, properties = {}, fbq = currentFbq()) {
  const mapping = eventMapping[event];
  if (!mapping || !fbq) return false;

  fbq(mapping[0], mapping[1], metaProperties(properties));
  return true;
}
